import React, { useState } from 'react';

const CollapsibleParagraph = ({ title, children }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleCollapse = () => setIsOpen(prev => !prev);

  return (
    <div className="mb-2">
      <div
      onClick={toggleCollapse}
      style={{ cursor: 'pointer' }}
      className=" d-flex gap-2"
    >
      <div className=''>
        <svg
          height={70}
          fill="rgb(0, 168, 181)"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d={isOpen ? 'M7 10l5 5 5-5H7z' : 'M10 17l5-5-5-5v10z'} />
        </svg>
      </div>
      <strong className="mil-h4 align-content-center">{title}</strong>
    </div>

      {isOpen && <p className="mil-h5 mil-thin ps-4">{children}</p>}
    </div>
  );
};

export default CollapsibleParagraph;
